import { Helmet } from "react-helmet-async";
import { Info, DollarSign, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import "./style.css";

const Ads = () => {
    return (
        <>
            <Helmet>
                <title>Paçoca - Anúncios</title>
                <meta name="description" content={`Saiba como funciona anúncios e propagandas no Paçoca!`} />
                <meta name="keywords" content={`Paçoca, rede social brasileira, Anúncios, propaganda, marketing}`} />
                <meta name="author" content="Paçoca Inc." />
                <meta property="og:title" content={`Paçoca - como os anuncios funcionam`} />
                <meta property="og:description" content={`Saiba como funciona anúncios e propagandas no Paçoca!`} />
                <meta property="og:image" content="/img/link-preview.png?v=1" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`Paçoca - como os anuncios funcionam`} />
                <meta name="twitter:description" content={`Saiba como funciona anúncios e propagandas no Paçoca!`} />
                <meta name="twitter:image" content="/img/link-preview.png?v=1" />
            </Helmet>

            <div className="spacer-ads"></div>

            {/* ---------- Hero ---------- */}
            <section className="section-ads">
                <div className="container ads-container">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="ads-home-hero">
                                <h1 className="ads-home-hero-title">Anúncie no Paçoca</h1>
                                <p className="ads-home-hero-sub">Alcance milhares de pessoas e divulgue sua campanha</p>
                                <div className="ads-home-hero-actions">
                                    <Link to={"/anuncios/novo"} className="ads-btn ads-btn-primary">
                                        Criar anúncio
                                    </Link>
                                    <Link to={"/anuncios/meus-anuncios"} className="ads-btn ads-btn-outline">
                                        Meus anúncios
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex align-items-center justify-content-center">
                            <img src="/img/ads/ads.png" alt="Anúncios Paçoca" className="img-ads" />
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------- Stat card ---------- */}
            <section className="section-ads">
                <div className="container ads-container">
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="ads-home-stat-card">
                                <div className="ads-home-stat-icon-wrap">
                                    <DollarSign size={22} />
                                </div>
                                <div>
                                    <div className="ads-home-stat-number">35k</div>
                                    <div className="ads-home-stat-label">Usuários ativos na plataforma</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-6 col-xl-6 d-flex align-items-center justify-content-center">
                            <Link to={"/dashboard"} className="ads-btn ads-btn-outline">
                                Visualizar Dashboard
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------- Como funciona ---------- */}
            <section className="section-ads">
                <div className="container ads-container">
                    <p className="ads-home-section-label">Como funciona?</p>
                    <h2 className="ads-home-section-title">Do cadastro ao ar em minutos</h2>
                    <p className="ads-home-section-text">
                        Entenda o processo completo, da criação do anúncio até ele ficar no ar.
                    </p>

                    <div className="ads-home-steps">
                        <div className="ads-home-step">
                            <div className="ads-home-step-icon-wrap">
                                <DollarSign size={18} />
                            </div>
                            <div className="ads-home-step-content">
                                <div className="ads-home-step-title">Cobrança por visualização</div>
                                <div className="ads-home-step-text">
                                    No Paçoca, os anúncios são cobrados com base na quantidade de visualizações. Ao criar
                                    seu anúncio, você define o número máximo de visualizações desejadas — e só paga por
                                    isso. Assim que esse limite for atingido, o anúncio deixa de ser exibido
                                    automaticamente.
                                </div>
                                <img src="/img/ads/1.png" alt="Definindo visualizações" className="ads-home-step-img" />
                            </div>
                        </div>

                        <div className="ads-home-step">
                            <div className="ads-home-step-icon-wrap">
                                <ShieldCheck size={18} />
                            </div>
                            <div className="ads-home-step-content">
                                <div className="ads-home-step-title">Análise automática por IA</div>
                                <div className="ads-home-step-text">
                                    Antes de ir ao ar, todo anúncio passa por uma análise automática feita por nossa
                                    inteligência artificial, que verifica se o conteúdo está de acordo com nossas
                                    políticas e diretrizes. Isso garante mais segurança e qualidade para os usuários da
                                    plataforma.
                                </div>
                                <img src="/img/ads/2.png" alt="Análise por IA" className="ads-home-step-img" />
                            </div>
                        </div>

                        <div className="ads-home-step">
                            <div className="ads-home-step-icon-wrap">
                                <Info size={18} />
                            </div>
                            <div className="ads-home-step-content">
                                <div className="ads-home-step-title">Pagamento e publicação</div>
                                <div className="ads-home-step-text">
                                    O pagamento é realizado antes da análise. Caso o anúncio seja reprovado, ele não será
                                    publicado e não haverá reembolso automático. Se você considerar que a reprovação foi
                                    injusta, é possível solicitar uma reavaliação entrando em contato com nossa equipe
                                    pelo Discord. Após a aprovação da IA, o anúncio é publicado automaticamente.
                                </div>
                                <img src="/img/ads/3.png" alt="Pagamento e publicação" className="ads-home-step-img" />
                            </div>
                        </div>
                    </div>

                    <div className="ads-notice ads-notice-warning mt-4">
                        <span className="ads-notice-icon">⚠️</span>
                        <div>
                            Anúncios reprovados pela IA <strong>não têm reembolso automático</strong>. O reembolso só é
                            analisado manualmente caso o conteúdo esteja de acordo com nossas diretrizes.
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------- Status do anúncio ---------- */}
            <section className="section-ads">
                <div className="container ads-container">
                    <p className="ads-home-section-label">Status do Anúncio</p>
                    <h2 className="ads-home-section-title">Acompanhe cada etapa</h2>
                    <p className="ads-home-section-text">
                        Acompanhe em qual etapa o seu anúncio está a qualquer momento.
                    </p>

                    <div className="ads-home-status-grid">
                        <div className="ads-home-status-card">
                            <span className="ads-badge ads-badge-active">✔ Ativo</span>
                            <div className="ads-home-status-text">O anúncio está publicado e visível.</div>
                        </div>

                        <div className="ads-home-status-card">
                            <span className="ads-badge ads-badge-validating">🔎 Validando conteúdo</span>
                            <div className="ads-home-status-text">Aguardando aprovação do Paçoca IA.</div>
                        </div>

                        <div className="ads-home-status-card">
                            <span className="ads-badge ads-badge-pending">💰 Pagamento pendente</span>
                            <div className="ads-home-status-text">
                                O pagamento ainda não foi identificado (clique em verificar pagamento, se você já pagou).
                            </div>
                        </div>

                        <div className="ads-home-status-card">
                            <span className="ads-badge ads-badge-online">📢 Online</span>
                            <div className="ads-home-status-text">O anúncio foi aprovado e está rodando.</div>
                        </div>

                        <div className="ads-home-status-card">
                            <span className="ads-badge ads-badge-off">⛔ Atingiu o esperado</span>
                            <div className="ads-home-status-text">
                                O limite de visualizações foi atingido e o anúncio parou.
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Ads;
